import { useEffect, useState } from "react";
import Header from "@/pages/home/components/Header";
import Hero from "@/pages/home/components/Hero";
import FateMatch from "@/pages/home/components/FateMatch";
import BlindBox from "@/pages/home/components/BlindBox";
import Roam from "@/pages/home/components/Roam";
import Popular from "@/pages/home/components/Popular";
import Categories from "@/pages/home/components/Categories";
import About from "@/pages/home/components/About";
import FAQ from "@/pages/home/components/FAQ";
import Footer from "@/pages/home/components/Footer";

function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-40 w-11 h-11 flex items-center justify-center rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 shadow-md cursor-pointer"
    >
      <i className="ri-arrow-up-line text-xl"></i>
    </button>
  );
}

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FateMatch />
        <BlindBox />
        <Roam />
        <Popular />
        <Categories />
        <About />
        <FAQ />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}